export default function PHP_scandir() {
  return (
    <div>
      <h1>PHP_scandir</h1>
    </div>
  );
}
